<template>
    <div>
      <div class="search_wrap">
        <el-form
          :model="queryParam"
          ref="form"
          label-width="80px"
          :inline="true"
          size="mini"
        >
          <el-form-item label="指导员">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.createBy"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        <div class="selectBox">
          <span class="selectText">状态</span>
          <el-select
            v-model="queryParam.type"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="请选择" value></el-option>
            <el-option label="通过" value="1">交投</el-option>
            <el-option label="拒绝" value="2">兑换</el-option>
          </el-select>
        </div>
  
          <el-form-item>
            <el-button type="primary" @click="searchQuery">查询</el-button>
            <el-button type="default" @click="searchReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <e-table
        :listLoading="loading"
        :selection="true"
        :tableHeadConfig="columns"
        @pageChange="loadData"
        :paginationData="ipagination"
        :tableLoadData="dataSource"
        @selectLine="onSelectChange"
        :tableRowClassName="tableRowClassName"
      >
      <template #type="slotData">
        <p v-if="slotData.data.row.type == 1">交投</p>
        <p v-if="slotData.data.row.type == 2">兑换</p>
      </template>
      </e-table>
    </div>
  </template>
  
  <script>
  import eTable from "@/components/table";
  import { listMixin } from "@/mixins/listMixin";
  export default {
    name: "deviceList",
    components: { eTable },
    mixins: [listMixin],
    created() {},
    mounted() {
    },
    computed: {},
    watch: {},
    data() {
      return {
        url: {
          list: "/wlCarbonEnergyLogo/queryPage",
        },
        queryParam: {},
        columns: [
          {
            field: "wlGuidanceUserName",
            label: "指导员",
          },
          {
            field: "nickname",
            label: "用户名称",
          },
          {
            field: "wlPhone",
            label: "用户手机号",
          },
          {
            field: "wlCommunityName",
            label: "社区名称",
          },
          {
            label: "状态",
            slotName: "type",
            columnType: "slot",
          },
          {
            field: "kitchenWeight",
            label: "厨余重量",
          },
          {
            field: "totalCarbonEnergy",
            label: "总碳能量",
          },
          {
            field: "epgAmount",
            label: "环保金",
          },
          {
            field: "createTime",
            label: "操作时间",
          },
        ],
      };
    },
    methods: {
    },
  };
  </script>
  
  <style scoped lang="less">
  .search_wrap {
    margin: 10px 0;
  }
  .selectBox {
    margin-bottom: 18px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }
  .selectText {
    width: 80px;
    line-height: 28px;
    font-weight: 700;
    cursor: default;
    float: none;
    display: inline-block;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  </style>
  